// utils/auth.js
import { jwtDecode } from 'jwt-decode';

export const isTokenValid = (token) => {
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decoded.exp && decoded.exp > currentTime;
    } catch (error) {
        localStorage.clear();
        return false;
    }
};

export const getAccessToken = () => localStorage.getItem('token');